






















































import {
  defineComponent,
  onMounted,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter } from '@ideavivat/vivat-2';

import {
  getMaterials,
  getJobs,
} from '@/api';
import { Job } from '@/types/job';
import { PaginatorInfo, paginatorInfo } from '@/types';

import RadioCheckboxWithIcon from '@/components/RadioCheckboxWithIcon.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';

const List = defineComponent({
  components: {
    RadioCheckboxWithIcon,
    StickyFooterActionBar,
  },
  setup() {
    const { route, router } = useRouter();
    const form = reactive({
      detail: '',
      amount: '',
      unit: '',
      date: '',
    });
    // const getJobFirstTime = ref(true);
    const jobs: Ref<Job[]> = ref([]);
    const jobPage = ref(1);
    const jobPaginatorInfo: Ref<PaginatorInfo> = ref(paginatorInfo);
    const filter = reactive({
      code: '',
      pendingSearch: false,
    });

    async function getJobsData() {
      const { data: result, ...pagination } = (await getJobs({
        searchString: filter.code !== '' ? filter.code : undefined,
        orderBy: [{ field: 'created_at', order: 'DESC' }],
        'page[number]': jobPage.value,
        'page[size]': 15,
      })).data;

      const camelPagination = {
        from: pagination.from,
        to: pagination.to,
        lastPage: pagination.last_page,
        total: pagination.total,
        currentPage: pagination.current_page,
        perPage: pagination.per_page,
      };

      if (filter.pendingSearch || jobPaginatorInfo.value.currentPage === camelPagination.currentPage) {
        jobs.value = [];
        jobs.value = result;
        jobPage.value = 1;
        filter.pendingSearch = false;
      } else jobs.value = [...jobs.value, ...result, ...result];
      jobPaginatorInfo.value = camelPagination;
    }
    const pendingSearchAction = _.debounce(async () => {
      await getJobsData();
    }, 500);

    onMounted(async () => {
      await getJobsData();
    });

    function withdrawTypeChangeHandler(index: number) {
      if (index === 0 && route.value.params.bomId) router.push({ name: 'WithdrawCreateWithBomId', params: { bomId: route.value.params.bomId } });
      else if (index === 0) router.push({ name: 'WithdrawCreate' });
      else if (index === 1 && route.value.params.bomId) router.push({ name: 'DepositCreateWithBomId', params: { bomId: route.value.params.bomId } });
      else router.push({ name: 'DepositCreate' });
    }

    function scrollJobsAreaHandler(visible: any) {
      if (jobPaginatorInfo.value.lastPage > jobPage.value && visible) {
        jobPage.value += 1;
      }
    }
    watch(() => jobPage.value, async (newVal, oldVal) => {
      if (newVal !== oldVal) await getJobsData();
    });

    return {
      withdrawTypeChangeHandler,
      getJobs,
      getMaterials,
      filter,
      pendingSearchAction,
      scrollJobsAreaHandler,

      jobs,
      form,
    };
  },
});

export default List;
